import './prestige-stars.styles.scss';
import { prestigeStars } from '@shared/prestige.js';

// Prestige as five stars, filled to the nearest half. label: what the
// stars rate, for screen readers and the tooltip ("Conference prestige").
const PrestigeStars = ({ value, label = 'Prestige' }) => {
    const stars = prestigeStars(value);
    const text = `${label}: ${stars} of 5`;
    return (
        <span className='prestige-stars' role='img' aria-label={text} title={text}>
            <span className='stars-empty' aria-hidden='true'>★★★★★</span>
            <span className='stars-full' aria-hidden='true' style={{ width: `${stars * 20}%` }}>★★★★★</span>
        </span>
    );
}

export default PrestigeStars
